export class PayloadAbstract {
    page: Number | undefined;
    search: String | undefined;
}
